import { useContext, createContext, useEffect, useState } from "react";
import { ExclamationCircleOutlined } from "@ant-design/icons";
import { Modal } from "antd";

import { GET_TOKEN_EGRESADOS, REMOVE_TOKEN_EGRESADOS, TOKEN_EGRESADOS } from "../../../shared/constants";
import LoginService from "./../services/alumnos/LoginServices";

const AuthContext = createContext();

export const AuthEgresadosProvider = ({ children }) => {
    const [isAuthenticated, setIsAuthenticated] = useState(null);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);

    useEffect(() => {
        const checkAuth = async () => {
            const token = GET_TOKEN_EGRESADOS();
            if (!token) {
                setIsAuthenticated(false);
                return;
            }

            const isValidToken = await LoginService.checkToken(token);
            setIsAuthenticated(isValidToken?.success);
        }
        checkAuth();
        setLoading(false);
    }, []);

    const login = async (token) => {
        setLoading(true);
        localStorage.setItem(TOKEN_EGRESADOS, token);
        setIsAuthenticated(true);
        setLoading(false);
    };

    const logout = () => {
        Modal.confirm({
            title: '¡Confirmar!',
            icon: <ExclamationCircleOutlined />,
            content: '¿Estás seguro de cerrar la sesión?',
            okText: 'Aceptar',
            cancelText: 'Cancelar',
            maskClosable: true,
            okButtonProps: {
                className: "custom-submit-button",
            },
            onOk: () => {
                REMOVE_TOKEN_EGRESADOS();
                setIsAuthenticated(false);
            }
        })
    };

    return (
        <AuthContext.Provider
            value={
                {
                    isAuthenticated,
                    error,
                    setError,
                    login,
                    logout,
                    loading, 
                }}>
            {children}
        </AuthContext.Provider>
    )
};

export const useAuth = () => useContext(AuthContext);